import classNames from 'classnames';
import { DefaultCardProps } from './default-card-props';
import { useDefaultCardStyles } from './default-card-styles';

export const DefaultCard = ({
  onClick,
  onCheck,
  isSelected,
  children,
  className
}: DefaultCardProps) => {
  const classes = useDefaultCardStyles({
    possuiClick: Boolean(onClick)
  });

  return (
    <>
      <div
        onClick={onClick}
        className={classNames(
          classes.cardContainer,
          isSelected ? classes.cardSelected : undefined,
          className
        )}
      >
        {children}
      </div>
    </>
  );
};
